import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { Guid } from 'guid-typescript';
import { IAddBetalingResponse } from '@/model/IAddBetalingResponse';
import { IBetalingStatus } from '@/model/IBetalingStatus';

class AppBetalingenService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public addBetaling(
    hypotheeknummer: string,
    hypotheekdeelnummer: string,
    aflossingsbedrag: number
  ): Promise<IAddBetalingResponse> {
    const data = {
      id: Guid.createEmpty().toString(),
      hypotheeknummer,
      hypotheekdeelnummer,
      aflossingsbedrag
    };
    return apiClient.post<IAddBetalingResponse>('Betalingen', data).then(response => {
      return response.data;
    });
  }

  public cancelBetaling(betalingId: string): Promise<void> {
    return apiClient.delete<void>(`Betalingen/${betalingId}`).then(response => {
      return response.data;
    });
  }

  public getBetalingStatus(betalingId: string): Promise<IBetalingStatus> {
    return apiClient.patch<IBetalingStatus>(`Betalingen/${betalingId}`).then(response => {
      return response.data;
    });
  }
}

export const appBetalingenService = new AppBetalingenService();
